module.exports = __webpack_public_path__ + "assets/img/Sonance_003.ed21999b.jpg";